
/* eslint-disable */
// disable because of thse warnings:
// Line 153:32:  eval can be harmful               no-eval
//   Line 157:31:  eval can be harmful               no-eval
//   Line 170:34:  Unnecessary escape character: \d  no-useless-escape 
//   Line 170:37:  Unnecessary escape character: \.  no-useless-escape 
//   Line 170:40:  Unnecessary escape character: \d  no-useless-escape 

import { useTheme } from '@mui/material';
import { InputMask } from '@react-input/mask';
import { CustomCellEditorProps, useGridCellEditor } from "ag-grid-react";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import useDebounce from '../../../hooks/use-debounce/UseDebounce';
import { getTotalFromFeetAndInchesText } from '../../../common/utilities/FeetAndInches';

const KEY_BACKSPACE = 'Backspace';
const KEY_DELETE = 'Delete';
const KEY_ENTER = 'Enter';
const KEY_TAB = 'Tab';
const KEY_SPACE = 'Space';

export type IFeetAndInchesMaskCellEditorProps = {
    lowerBound?: number;
    lowerBoundOp?: string;
    upperBound?: number;
    upperBoundOp?: string;
    unit?: string;
} & CustomCellEditorProps;


export function FeetAndInchesMaskedCellEditor({
    lowerBound,
    lowerBoundOp,
    upperBound,
    upperBoundOp,
    unit,
    value,
    eGridCell,
    eventKey,
    data,
    onValueChange
}: IFeetAndInchesMaskCellEditorProps) {

    const theme = useTheme();
    const [highlightAllOnFocus, setHighlightAllOnFocus] = useState(true);
    const refInput = useRef<HTMLInputElement>(null);

    const [newValue, setNewValue] = useState(value ?? "");
    const debouncedValue = useDebounce(newValue, 1000);

    const [valid, setValid] = useState(true);



    const valueChangeRef = useRef(onValueChange);

    useEffect(() => {
        valueChangeRef.current = onValueChange;
    }, [onValueChange]);

    // Using onValueChange directly requires it to be added
    // to the dependency array, which causes recursive renders.
    useEffect(() => {
        if (valid) {
            valueChangeRef.current && valueChangeRef.current(debouncedValue);
        }
    }, [
        debouncedValue,
        valid
    ]);

    useEffect(() => {
        setNewValue(value ?? "");
        setValid(true);
    }, [
        value,
        setValid
    ]);



    // Takes the place of the old afterGuiAttached
    useEffect(() => {
        eGridCell.style.borderColor = '';
        data.valid = true;
        setValid(true);

        // setValue(props.value);
        if (refInput.current) {
            refInput?.current.focus();
            refInput?.current.select();
        }
    }, []);

    // focus on the input
    useEffect(() => {

        // get ref from React component
        const eInput = refInput.current;
        eInput?.focus();
        if (highlightAllOnFocus) {
            eInput?.select();

            setHighlightAllOnFocus(false);
        }
    }, [
        highlightAllOnFocus,
        setHighlightAllOnFocus,
        refInput
    ]);

    const cancelBeforeStart = !!eventKey && ('1234567890'.indexOf(eventKey) < 0);

    const isLeftOrRight = (event: React.KeyboardEvent<HTMLInputElement>) => {
        return ['ArrowLeft', 'ArrowRight'].indexOf(event.key) > -1;
    };

    const getCharCodeFromEvent = (event: React.KeyboardEvent<HTMLInputElement>) => {
        event = event || window.event;
        return event.key;
    };

    const isCharNumeric = (char: string) => {
        return !!/\d/.test(char);
    };

    const isKeyPressedNumeric = (event: React.KeyboardEvent<HTMLInputElement>) => {

        //console.log(`current value ${event.currentTarget.value} and key ${event.key}`);


        const charStr = event.key;
        return event.code === KEY_SPACE || isCharNumeric(charStr);
    };

    const deleteOrBackspace = (event: React.KeyboardEvent<HTMLInputElement>) => {
        return [KEY_DELETE, KEY_BACKSPACE].indexOf(event.key) > -1;
    };

    const finishedEditingPressed = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const charCode = getCharCodeFromEvent(event);
        return charCode === KEY_ENTER || charCode === KEY_TAB;
    };

    const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (isLeftOrRight(event) || deleteOrBackspace(event)) {
            event.stopPropagation();
            return;
        }

        if (!finishedEditingPressed(event) && !isKeyPressedNumeric(event)) {
            if (event.preventDefault) {
                event.preventDefault();
            }
        }
    };

    const onChanged = (event: React.ChangeEvent<HTMLInputElement>) => {

        const value = event.target.value.replace(/_/g, ' ').trim();

        const parts = value.split("'");
        if (parts.length > 2) {
            data.valid = false;
            eGridCell.style.borderColor = theme.palette.error.main;
            return;
        }

        const feet = parts[0].replace(/_/g, '').trim();
        let inches = parts[1].replace(/ |_/g, '').replace('"', '');
        if (inches === '') {
            inches = '0';
        }

        if ((+inches) > 11.99 || isNaN(+feet) || isNaN(+inches)) {
            setValid(false);
            data.valid = false;
            eGridCell.style.borderColor = theme.palette.error.main;
            return;
        }

        eGridCell.style.borderColor = '';        

        const newValue = `${feet}' ${(+(inches)).toFixed(2)}"`;


        if ((lowerBound && lowerBoundOp) || (upperBound && upperBoundOp)) {

            let rawValue = getTotalFromFeetAndInchesText(newValue);
            if (rawValue && unit?.toLowerCase() === 'feet') {
                rawValue /= 12;
            }

            let valid = true;
            if (lowerBound !== undefined && lowerBound !== null && lowerBoundOp !== undefined && lowerBoundOp !== null) {
                valid = (0, eval)(`${rawValue} ${lowerBoundOp} ${lowerBound}`);
            }
    
            if (valid && upperBound !== undefined && upperBound !== null && upperBoundOp !== undefined && upperBoundOp !== null) {
                valid = (0, eval)(`${rawValue} ${upperBoundOp} ${upperBound}`);
            }

            if (!valid) {
                setValid(false);
                data.valid = false;
                eGridCell.style.borderColor = theme.palette.error.main;
                return;
            }
        }

        data.valid = true;
        setValid(true);
        setNewValue(newValue);
    };


    /* ag-grid component Editor Lifecycle methods */
    // useImperativeHandle(ref, () => {
    //     return {
    //         // the final value to send to the grid, on completion of editing
    //         getValue() {
    //             let v = `${value}`;
    //             if (v.endsWith('.')) {
    //                 return v.replace('.', '');
    //             }
    //             return v;
    //         },
    //         afterGuiAttached: () => {
    //             props.eGridCell.style.borderColor = '';
    //             props.data.valid = true;

    //             setValue(props.value);
    //             if (refInput.current) {
    //                 refInput?.current.focus();
    //                 refInput?.current.select();
    //             }
    //         },            

    //         // Gets called once before editing starts, to give editor a chance to
    //         // cancel the editing before it even starts.
    //         isCancelBeforeStart() {
    //             return cancelBeforeStart;
    //         },

    //         // Gets called once when editing is finished (eg if enter is pressed).
    //         // If you return true, then the result of the edit will be ignored.
    //         isCancelAfterEnd() {
    //             return false;
    //         }
    //     };
    // });

    const isCancelBeforeStart = useCallback(() => {
        return cancelBeforeStart;
    }, [
        cancelBeforeStart
    ]);

    const isCancelAfterEnd = useCallback(() => {
        return false;
    }, []);

    useGridCellEditor({
        isCancelBeforeStart,
        isCancelAfterEnd
    });

    return (
        <InputMask
            ref={refInput}
            mask={`___' __.__"`}
            showMask={true}
            replacement={{ _: /[ 0-9]/ }}
            defaultValue={value}
            onChange={onChanged}
            onKeyDown={onKeyDown}
            style={{
                backgroundColor: theme.palette.background.paper,
                background: 'transparent',
                border: 'none',
                padding: '3px',
                outline: 'none',
            }}
        />
    );
};

